import React from 'react';
import { motion } from 'framer-motion';
import { Search, GitBranch, Target } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const cards = [
  {
    icon: Search,
    title: 'Gather the evidence',
    desc: 'Surveys, focus groups, leadership conversations and existing workplace information.',
  },
  {
    icon: GitBranch,
    title: 'Make sense of the pressure',
    desc: 'Identify patterns, gaps and likely causes rather than treating each symptom in isolation.',
  },
  {
    icon: Target,
    title: 'Agree what happens next',
    desc: 'Help leaders prioritise practical action and decide how progress will be measured.',
  },
];

const WhatWeDoSection = () => {
  return (
    <section className="py-20 md:py-28 bg-gray-50" data-testid="what-we-do-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="max-w-3xl mb-12" {...fadeInUp}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-carbon mb-6 tracking-tight">
            WE HELP YOU <span className="yellow-highlight text-carbon">FIND OUT</span> WHAT IS <span className="yellow-highlight text-carbon">REALLY</span> HAPPENING
          </h2>
          <p className="text-base text-carbon/80 leading-relaxed mb-4">
            Kalobrate brings together employee experience, leadership insight and workplace data
            to build a clearer picture of where culture is helping performance and where it is
            creating pressure.
          </p>
          <p className="text-base text-carbon/80 leading-relaxed">
            You receive clear findings, agreed priorities and practical recommendations that fit
            the organisation, rather than a list of generic wellbeing activities.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              className="bg-white border border-gray-100 p-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="w-10 h-10 bg-golden flex items-center justify-center mb-5">
                <card.icon className="w-5 h-5 text-carbon" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-carbon mb-3">{card.title}</h3>
              <p className="text-sm text-carbon/70 leading-relaxed">{card.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
